__turbopack_context__.v({
  "announcementButton": "inline-announcements-module-scss-module__OyU4zW__announcementButton",
  "announcementContainer": "inline-announcements-module-scss-module__OyU4zW__announcementContainer",
  "announcementText": "inline-announcements-module-scss-module__OyU4zW__announcementText",
  "blueBackground": "inline-announcements-module-scss-module__OyU4zW__blueBackground",
  "eyebrowContainer": "inline-announcements-module-scss-module__OyU4zW__eyebrowContainer",
  "greenBackground": "inline-announcements-module-scss-module__OyU4zW__greenBackground",
  "indigoBackground": "inline-announcements-module-scss-module__OyU4zW__indigoBackground",
  "inlineAnnouncement": "inline-announcements-module-scss-module__OyU4zW__inlineAnnouncement",
  "leftButtonContainer": "inline-announcements-module-scss-module__OyU4zW__leftButtonContainer",
  "linkContainer": "inline-announcements-module-scss-module__OyU4zW__linkContainer",
  "orangeBackground": "inline-announcements-module-scss-module__OyU4zW__orangeBackground",
  "redBackground": "inline-announcements-module-scss-module__OyU4zW__redBackground",
  "rightButtonContainer": "inline-announcements-module-scss-module__OyU4zW__rightButtonContainer",
  "titleContainer": "inline-announcements-module-scss-module__OyU4zW__titleContainer",
  "yellowBackground": "inline-announcements-module-scss-module__OyU4zW__yellowBackground",
});
